import { TFunction } from 'i18next';
import { DateTime } from 'luxon';

import {
  EventTableConfig,
  EventTableInterval,
  EventTableType,
} from '@/components/eventComponent/types.ts';
import { toApiDateTime } from '@/utils';

export const getDefaultTableConfig = (
  t: TFunction<['common', 'eventStream']>
): EventTableConfig => {
  const now = DateTime.now();
  return {
    title: t('eventStream:eventTable'),
    rootId: '',
    type: EventTableType.LIVE,
    historicalPageSize: 20,
    historyDefaultSorting: [{ id: 'timestamp', desc: true }],
    historyDefaultFilters: [],
    from: toApiDateTime(now.minus({ days: 1 })),
    to: toApiDateTime(now),
    liveInterval: EventTableInterval.Short,
    livePageSize: 1000,
    liveDefaultSorting: [{ id: 'timestamp', desc: true }],
    liveDefaultFilters: [],
  };
};
